
// The Tender award edit functions 
var TECL_UserTenderAwardEdit = {

  // Initialise the Tenders edit page
  Initialise: function() {
  },

  // Award continue button selected 
  ContinueSelected: function() {

    var saveData = {
      TenderId: $("#TenderId").val(),
      FinalPrice: $("#tenderAwardFinalPriceValue").val(),
      MoneySaved: $("#tenderAwardPriceSavingValue").val(),
      StarRating: $("#tenderAwardStarRatingValue").val(),
      ImprovementText: $("#tenderAwardImprovementTextValue").val()
    }

    if (TECL_Master.AddLock("TECL_UserTenderAwardEdit_ContinueSelected")) {
      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnAward",
        dataType: "json",
        type: "POST",
        data: {
          saveData: saveData
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_UserTenderAwardEdit_ContinueSelected");
        },
        success: function(saveData) {
          TECL_Master.ClearLock("TECL_UserTenderAwardEdit_ContinueSelected");

          if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
            window.location = saveData.NextStageUrl;
          } else {
            TECL_Master.ShowErrorDialog("Failed to save stage change.");
          }
        }
      });
    }
  },

  // Show the message to the supplier
  ShowSupplierEmail: function() {
    var message = $("#supplierMessageText").val();

    // validate the message
    if (message && message.length > 0) {
      $("#supplierMessageErr").addClass("hidden");

      if (TECL_Master.AddLock("TECL_UserTenderAwardEdit_ShowSupplierEmail")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ShowAwardedSupplierMessage",
          dataType: "json",
          type: "POST",
          data: {
            message: message
          },
          error: function() {
            TECL_Master.ClearLock("TECL_UserTenderAwardEdit_ShowSupplierEmail");
          },
          success: function(result) {
            TECL_Master.ClearLock("TECL_UserTenderAwardEdit_ShowSupplierEmail");

            if (result) {
              var $dlg = $("#sentSupplierMessageDlg");
              $dlg.find("[name=dlgTitle]").html(result.TitleTextString);
              $dlg.find("[name=dlgBody]").html(result.BodyTextString);
              $dlg.modal("show");
            } else {
              TECL_Master.ShowErrorDialog("Failed to save stage change.");
            }
          }
        });
      }
    } else {
      $("#supplierMessageErr").removeClass("hidden");
    }
  },

  // Send the message to the supplier
  SendSupplierEmail: function() {
    var message = $("#supplierMessageText").val();

    // validate the message
    if (message && message.length > 0) {
      $("#supplierMessageErr").addClass("hidden");

      var tenderid = $("#TenderId").val();
      var tenderName = $("#TenderName").val();
      var supplierId = $("#SupplierId").val();
      var supplierEmail = $("#SupplierEmail").val();

      if (TECL_Master.AddLock("TECL_UserTenderAwardEdit_SendSupplierEmail")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/SendAwardedSupplierMessage",
          dataType: "json",
          type: "POST",
          data: {
            tenderId: tenderid,
            tenderName: tenderName,
            supplierId: supplierId,
            supplierEmail: supplierEmail,
            message: message
          },
          error: function(exc) {
            TECL_Master.ClearLock("TECL_UserTenderAwardEdit_SendSupplierEmail");
          },
          success: function(result) {
            TECL_Master.ClearLock("TECL_UserTenderAwardEdit_SendSupplierEmail");

            if (result.Sent) {
              window.location.reload(true);
            } else {
              TECL_Master.ShowErrorDialog("Failed to send the supplier message.");
            }
          }
        });
      }
    } else {
      $("#supplierMessageErr").removeClass("hidden");
    }
  },

  // Display the Sent Supplier Message dialog
  DisplaySentMessageInfoDlg: function() {
    var $dlg = $("#sentMessageInfoDlg");
    if ($dlg) {
      $dlg.modal("show");
    }
  }

};
